<template>
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
  >
    <!-- מודאל -->
    <div
      class="relative flex flex-col w-full max-w-[659px] bg-white rounded shadow-modal px-6 pt-8 pb-6 text-right font-medium mx-10 sm:mx-10"
      role="dialog"
      aria-modal="true"
    >
      <!-- כפתור סגירה -->
      <button
        @click="emitClose"
        aria-label="סגור"
        class="absolute top-4 left-4 text-grays-700 hover:text-black"
      >
        <span class="material-symbols-rounded text-[24px]">close</span>
      </button>

      <!-- כותרת ראשית -->
      <div class="w-full flex justify-center mt-5 mb-2">
        <b
          class="text-[24px] leading-[125%] font-bold text-transparent text-center font-sans !bg-clip-text [background:linear-gradient(173.04deg,_#3f238b,_#18054b)] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent]"
        >
          נפתחה תחנה חדשה!
        </b>
      </div>

      <!-- שם תחנה -->
      <section class="flex flex-col items-center gap-2 mt-6">
        <p class="text-sm text-grays-600">שם תחנה</p>
        <p class="text-xl font-bold text-primary-500">{{ stationName }}</p>
      </section>

      <!-- פרטי התחנה -->
      <div
        class="w-full max-w-[600px] flex flex-wrap custom-modal:flex-col md:flex-row justify-center items-center gap-4 mt-4 mb-5 text-base text-grays-900 font-sans text-right mx-auto px-4"
      >
        <!-- ימים -->
        <div class="flex items-center gap-1">
          <span class="material-symbols-rounded text-[20px]"
            >calendar_today</span
          >
          <span>{{ distributionDay }}</span>
        </div>

        <!-- פרטי חניה -->
        <div class="flex items-center gap-1">
          <span class="material-symbols-rounded text-[20px]"
            >assistant_navigation</span
          >
          <span>{{ locationDescription }}</span>
        </div>

        <!-- כתובת -->
        <div class="flex items-center gap-1">
          <span class="material-symbols-rounded text-[20px]">location_on</span>
          <span>{{ streetAddress }}</span>
        </div>
      </div>

      <!-- קו הפרדה -->
      <hr class="-mx-6 border-t-2 border-grays-300 my-6" />

      <div
        class="w-full flex justify-end items-center gap-4 mt-2 text-base font-noto-sans-hebrew-new"
      >
        <!-- כפתור סגור -->
        <button
          class="text-primary-700 font-medium hover:text-primary-900 transition"
          @click="emitClose"
        >
          סגור
        </button>

        <!-- כפתור פעולה -->
        <button
          class="bg-primary-700 text-white min-w-[240px] h-10 px-4 rounded-[5px] flex items-center justify-center font-medium shadow-button transition"
          @click="emitConfirm"
        >
          אני רוצה לעבור לתחנה החדשה!
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  stationName: String,
  distributionDay: String,
  locationDescription: String,
  streetAddress: String,
});

const emit = defineEmits(["close", "confirm"]);

const emitClose = () => {
  // Save to localStorage to prevent showing this modal again
  localStorage.setItem(
    `station-suggestion-dismissed-${props.stationName}`,
    "true"
  );
  emit("close");
};

const emitConfirm = () => emit("confirm");
</script>
